import React, { useReducer, useState, useEffect } from "react";
import { Box } from "@material-ui/core";

import { CustomDialog } from "../CustomDialog";

import { GoogleMapsComponent } from "../..";

function CustomMapDialog(props) {
  const reducer = (state, action) => ({ ...state, [action.id]: action.value });
  const [state, setState] = useReducer(reducer, props.initialState);

  const [location, setLocation] = useState("");
  useEffect(() => {
    setLocation(
      state?.latitude && state?.longitude
        ? `${state.latitude},${state.longitude}`
        : ""
    );
  }, [state]);

  const locationChangeHandler = (event) => {
    let locationSeparated = event.target.value;
    locationSeparated = locationSeparated.replace(/[^.,\d]+/g, "");
    setLocation(locationSeparated);
    locationSeparated = locationSeparated.split(",");

    if (locationSeparated.length >= 2) {
      setState({ id: "latitude", value: +locationSeparated[0] });
      setState({ id: "longitude", value: +locationSeparated[1] });
    } else {
      setState({ id: "latitude", value: null });
      setState({ id: "longitude", value: null });
    }
  };

  return (
    <CustomDialog
      onClose={() => {
        props.closeDialog();
      }}
      open={props?.open}
      subtitle={"Share where you’ve worked on your profile."}
      onConfirm={(event) => {
        event.preventDefault();
        props.onChange(state);
        props.closeDialog();
      }}
      isDisabled={false}
      title="Map"
      confirmText={"Save"}
      width={"688px"}
      content={
        <Box>
          <GoogleMapsComponent
            isNewLayout={true}
            location={location}
            locations={
              (state && [
                {
                  latitude: state?.latitude,
                  longitude: state?.longitude,
                },
              ]) ||
              []
            }
            onChange={locationChangeHandler}
            onClick={(location) => {
              setState({ id: "latitude", value: location.lat });
              setState({ id: "longitude", value: location.lng });
            }}
          />
        </Box>
      }
    />
  );
}

export default CustomMapDialog;
